class ShareCart extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="text"]');
    this.copyButton = this.querySelector('[data-copy-button]');
    this.shareUrlButton = this.querySelector('[data-share-url-button]');
    this.copiedText = this.querySelector('[data-copied-text]');
    this.copyButtonText = this.copyButton?.querySelector('.btn__text:not([data-copied-text])');
  }

  connectedCallback() {
    if (!this.input || !this.copyButton) return;

    // Generate share link on initialization
    this.generateShareLink();

    // Find the parent modal and listen for when it opens
    const modal = this.closest('cart-addon-modal');
    if (modal) {
      modal.addEventListener('modal:handleAfterShow', () => {
        this.generateShareLink();
      });
    }

    // Listen for cart updates to regenerate link
    document.addEventListener('cart:updated', () => {
      if (modal && modal.hasAttribute('open')) {
        this.generateShareLink();
      }
    });

    // Handle copy button click
    this.copyButton.addEventListener('click', () => {
      this.copyToClipboard();
    });

    // Handle share URL button click
    if (this.shareUrlButton) {
      this.shareUrlButton.addEventListener('click', () => {
        this.shareUrl();
      });
    }
  }

  generateShareLink() {
    const cartItems = document.querySelectorAll('cart-items .cart-item');
    
    if (!cartItems || cartItems.length === 0) {
      this.input.value = '';
      return;
    }

    const cartParams = [];
    
    cartItems.forEach((item) => {
      const variantId = item.dataset.variantId;
      const quantity = item.dataset.quantity || item.querySelector('quantity-input input')?.value || 1;
      
      if (variantId) {
        cartParams.push(`updates[${variantId}]=${quantity}`);
      }
    });

    if (cartParams.length === 0) {
      this.input.value = '';
      return;
    }

    // Build the shareable cart URL using the format from the image: id:VARIANT_ID,q:QUANTITY
    const cartUrl = `${window.shopUrl}/cart/update?${cartParams.join('&')}`;
    this.input.value = cartUrl;
  }

  async copyToClipboard() {
    if (!this.input || !this.input.value) return;

    try {
      await navigator.clipboard.writeText(this.input.value);
      this.showCopiedState();
    } catch (err) {
      // Fallback for older browsers
      this.input.select();
      this.input.setSelectionRange(0, 99999);
      try {
        document.execCommand('copy');
        this.showCopiedState();
      } catch (fallbackErr) {
        console.error('Failed to copy:', fallbackErr);
      }
    }
  }

  showCopiedState() {
    if (!this.copyButtonText || !this.copiedText) return;

    // Hide the copy text and show copied text
    this.copyButtonText.hidden = true;
    this.copiedText.hidden = false;

    // Reset after 2 seconds
    setTimeout(() => {
      this.copyButtonText.hidden = false;
      this.copiedText.hidden = true;
    }, 2000);
  }

  async shareUrl() {
    if (!this.input || !this.input.value) return;

    const shareUrl = this.input.value;
    const shareTitle = 'Share Cart';

    // Check if Web Share API is supported
    if (navigator.share) {
      try {
        await navigator.share({
          title: shareTitle,
          text: shareTitle,
          url: shareUrl,
        });
      } catch (err) {
        // User cancelled or error occurred
        if (err.name !== 'AbortError') {
          console.error('Error sharing:', err);
          // Fallback to copy if share fails
          this.copyToClipboard();
        }
      }
    } else {
      // Fallback to copy if Web Share API is not supported
      this.copyToClipboard();
    }
  }
}

customElements.define('share-cart', ShareCart);

